import store from '../../Modules/store/store';

const sidebarWrapper = document.getElementById('js-sidebar-wrapper');
const sidebarCloseTriggers = document.getElementsByClassName('js-sidebar-close-trigger');

function toggle() {
  // Dispatch to vuex store
  const targetState = !store.getters.expandSidebar;
  store.dispatch('setExpandSidebar', targetState);
}

store.watch(state => state.expandSidebar, (newState) => {
  sidebarWrapper.classList.toggle('sidebar-wrapper--open', newState);
});

if (sidebarWrapper) {
  window.addEventListener('load', () => {
    sidebarCloseTriggers.forEach((closeButton) => {
      closeButton.addEventListener('click', toggle, false);
    });

    window.setInterval(() => {
      const backdrop = document.getElementById('js-backdrop');
      if (backdrop && !backdrop.classList.contains('show')) {
        setTimeout(() => {
          // Re-check after 30ms - for internet explorer.
          if (!backdrop.classList.contains('show')) {
            sidebarWrapper.classList.remove('sidebar-wrapper--open');
          }
        }, 40);
      }
    }, 100);
  });
}
